<div fxLayout="column" fxFlex="100" fxLayoutGap="20px" class="absence-container">
  <div class="container" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
    <span class="header"><mat-icon class="icon">event</mat-icon> {{ 'WTL-Absences' | translate }}</span>

    <div class="content-card">
      <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
        @for (link of navigation; track link) {
          <mat-tab [label]="'AbsenceTabs.' + link.listType | translate" [visibleWithPermissions]="link.permissions">
          </mat-tab>
        }
      </mat-tab-group>
    </div>
    <div class="router-outlet-container">
      <router-outlet class="router-outlet"></router-outlet>
    </div>
  </div>
</div>
